import type { EarningsFilters } from "../types";

export const queryKeys = {
  earningsHistory: (filters: EarningsFilters) =>
    ["earnings-history", filters] as const,
  notifications: ["notifications", "recent"] as const,
  notification: (id: string) => ["notifications", id] as const,
  flexNotificationUrl: (domain: string, itemId: number) =>
    ["notifications", "flex", domain, itemId] as const,
  panelist: ["panelist"] as const,
  balance: ["balance"] as const,
  memberCheckIn: (checkInId: number) => ["checkin", checkInId] as const,
  publicPanel: (panelId?: number) =>
    ["public-panel", panelId || "host"] as const,
  sessionContext: (panelId?: number) =>
    ["session-context", panelId || ""] as const,
  profile: ["profile"] as const,
  file: (fileId: string) => ["file", fileId] as const,
  panelFields: ["panel", "fields"] as const,
  taskPre: (taskId: string) => ["task", taskId, "pre"] as const,
  task: (taskId: string) => ["task", taskId] as const,
  tasks: (rejectedTaskIds: string[] = [], forceRefreshKey: number = 0) =>
    ["tasks", { rejectedTaskIds, forceRefreshKey }] as const,
};
